import { render, staticRenderFns } from "./flowList.vue?vue&type=template&id=b477617a&"
import script from "./flowList.vue?vue&type=script&lang=js&"
export * from "./flowList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports